function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.9413 20.2908C34.7683 20.2908 32.0226 19.2479 29.7118 17.2174C27.5369 15.2931 26.9693 12.0859 28.3476 9.50874L28.3605 9.4856L23.1504 18.2977L23.0022 18.5546C25.1633 22.5331 29.2741 25.0021 33.7368 25.0021C38.1995 25.0021 42.3102 22.5331 44.4713 18.5546C42.5576 19.3538 40.3365 20.2908 37.9413 20.2908Z",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.9522 20.4595C34.9047 20.4629 31.9658 19.3063 29.7118 17.2164C27.5365 15.2923 26.9693 12.0845 28.3486 9.50777C28.3522 9.49983 28.3561 9.4921 28.3605 9.48462L23.1504 18.2912L23.0022 18.5492C25.1633 22.5277 29.2741 24.9967 33.7368 24.9967C38.1995 24.9967 42.3102 22.5277 44.4713 18.5492C42.519 19.8006 40.2587 20.463 37.9522 20.4595Z",
  fill: "url(#paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.3996 3.6543C42.4126 4.82168 42.7014 5.93504 42.7014 7.13659C42.7014 11.6639 39.3477 16.3048 36.9785 17.8028C34.6927 19.2561 31.7435 19.0182 29.7107 17.2164C33.7809 20.9806 39.8118 21.5261 44.4692 18.5513C47.1157 13.6708 46.2716 7.59459 42.3996 3.6543Z",
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.4496 2.94774C35.6424 2.94774 39.7805 7.74292 39.8681 12.3044V12.5006C39.8687 14.6578 38.7766 16.6624 36.9796 17.8029C41.7082 14.8695 43.9275 9.07615 42.3996 3.65434C39.6638 0.873239 35.8018 -0.431901 31.9771 0.132055C28.1525 0.696012 24.8121 3.06314 22.9621 6.52043L22.7923 6.80814C25.1031 4.89558 27.2733 2.94774 30.4496 2.94774Z",
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5078 17.0158C16.9958 16.6718 21.5157 12.6615 22.2092 12.1754L24.8056 10.2231C26.9563 8.72065 30.6346 6.18527 33.733 6.25471C37.1142 6.2547 39.8576 9.04316 39.8659 12.4885V12.3088C39.8666 8.13551 37.213 4.44307 33.3083 3.1838C29.4036 1.92453 25.1482 3.38888 22.7923 6.80258L17.6351 15.5232C17.3061 16.0543 16.929 16.5529 16.5089 17.0125",
  fill: "url(#paint4_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.733 6.25029C30.4874 6.07723 26.9174 8.67544 24.7699 10.1812L22.1735 12.1379C21.4789 12.6251 16.9525 16.5803 16.5068 17.0146C14.2046 19.2614 10.5967 19.3352 8.20795 17.1844C10.3889 19.2182 13.3024 20.6678 16.4927 20.6678C18.8868 20.6678 21.4605 20.3834 22.9989 18.5535L23.1471 18.2956L28.3573 9.48897L28.3443 9.51212C29.4194 7.50417 31.4849 6.25483 33.7297 6.2547",
  fill: "url(#paint5_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 18.5535C18.3276 21.5345 12.2777 20.9745 8.20904 17.1844C5.99303 15.1922 5.48679 11.8729 7.00495 9.28943C5.49036 10.5726 4.89102 13.4254 4.89102 15.8175C4.89102 19.1543 6.13514 23.1018 8.57578 24.4224C14.1416 26.2062 20.1708 23.753 23 18.5535Z",
  fill: "url(#paint6_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.20151 15.8142C5.19802 13.5111 5.82237 11.2522 7.00494 9.28945C8.58539 6.60033 11.8762 5.51986 14.7001 6.76289C13.6356 5.42795 11.3215 5.29016 9.43476 5.29016C5.81491 5.29016 2.2048 6.60415 0.311573 9.69181C-1.12007 16.0475 2.47872 22.458 8.58119 24.4224C6.40955 22.103 5.19906 19.0198 5.20151 15.8142Z",
  fill: "url(#paint7_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.1553 5.8744C11.4717 5.87401 12.7795 6.09029 14.0283 6.51486C14.2933 6.60966 14.4112 6.65596 14.6839 6.77281C14.977 6.9095 15.1588 6.99328 15.7159 7.31185C17.1615 8.11086 18.9682 7.60453 19.8094 6.16469C20.6507 4.72485 20.2263 2.86511 18.8479 1.95117C15.4876 -0.225347 11.2996 -0.604779 7.61515 0.933479C3.93069 2.47174 1.20806 5.73633 0.312647 9.6896C0.195388 10.2108 0.111191 10.7392 0.0605774 11.2715C2.34913 7.88975 6.12387 5.8716 10.1553 5.8744Z",
  fill: "url(#paint8_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 31.0054,
  y1: 17.2425,
  x2: 45.5143,
  y2: 17.2425,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C800CA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25CF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 26.2207,
  y1: 13.7041,
  x2: 43.5651,
  y2: 26.5946,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#4B206B",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9340D3",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 43.7906,
  y1: 2.27166,
  x2: 37.0191,
  y2: 18.1592,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#003FBF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#1E39C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#3B33C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#532ECA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#662ACC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#7327CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#7B25CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25CF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 22.9067,
  y1: 4.21292,
  x2: 40.8319,
  y2: 10.4666,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#038FF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#0278E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#0159D0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#0046C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#003FBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 10.4893,
  y1: 11.3419,
  x2: 35.7324,
  y2: 8.42841,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#038FF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#038DF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#0384EB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#0376DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0375DD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 18.5752,
  y1: 15.3074,
  x2: 34.5148,
  y2: 1.33414,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#43B64E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#40B555"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#38B16A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#2CAB8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#1AA3BB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#0498F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0398F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 7.42495,
  y1: 18.5878,
  x2: 20.8779,
  y2: 12.915,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#FACB02"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#EDCA07"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#D7C711"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#B7C41E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#8FBF2F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#5EB943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#43B64E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 8.84418,
  y1: 25.571,
  x2: 7.13467,
  y2: 7.63883,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 0.352435,
  y1: 5.57232,
  x2: 20.2535,
  y2: 5.79311,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#FF9800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C42222"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 46,
  height: 25,
  fill: "white"
})));

function SvgNavIco(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 25,
    viewBox: "0 0 46 25",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,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";
export { SvgNavIco as ReactComponent };